import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../shared/services/user-services/user.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-coustomer-coustomer-data-table',
  templateUrl: './coustomer-coustomer-data-table.component.html',
  styleUrls: ['./coustomer-coustomer-data-table.component.css'],
})
export class CoustomerCoustomerDataTableComponent implements OnInit {
  pagination = {
    limit: 10,
    currentPage: 1,
    status: '',
    name: '',
  };
  totalPage: number = 0;
  role: any = "reseller,merchant";
  customerData: any = [];
  rolesList: any;
  searchItem: any = '';
  totalRecords: any;
  userRole: any;
  permissions: any = [];
  private subject: Subject<string> = new Subject();
  constructor(
    private readonly userService: UserService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.userRole = this.userService.getUserRole();
    if (this.userRole == 'reseller') {
      this.role = ['merchant'];
    }
    // if (this.userRole == 'partner') {
    //   this.role = ['reseller'];
    // }
    this.subject.pipe(debounceTime(1000)).subscribe((searchTextValue) => {
      this.getCustomerCompanyViaSearch(
        searchTextValue,
        this.pagination,
        this.role
      );
    });
    this.getCustomerCompany(this.pagination);
    this.setPermissions('customer-profile');
  }
  getRoleViaSearch(e: any, pagination: any) {
    this.role = e.target.value;
    console.log('role', this.role);
    this.userService
      .getUsersWithPagination(pagination, this.searchItem, this.role)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.customerData = res.data.data;
          this.totalPage = res.data.totalPage;
          this.totalRecords = res.data.totalData;
        },
        error: (err) => console.error(err),
        complete: () => console.log('Observable complete'),
      });
  }
  setPermissions(type: string) {
    let allPermissions = JSON.parse(localStorage.getItem('permissions') as any);
    this.permissions = allPermissions.filter((item: any) => {
      return item.category == type;
    })[0].permissions;

    console.log(this.permissions);
  }
  onKeyUp(event: any, pagination: any) {
    this.subject.next(event);
  }
  getCustomerCompany(pagination: any) {
    // pagination.role = JSON.stringify(pagination.role);
    console.log(this.searchItem);
    this.userService
      .getUsersWithPagination(pagination, this.searchItem, this.role)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.customerData = res.data.data;
          this.totalPage = res.data.totalPage;
          this.totalRecords = res.data.totalData;
        },
        error: (err) => console.error(err),
        complete: () => console.log('Observable complete'),
      });
  }
  getCustomerCompanyViaSearch(e: any, pagination: any, role: any) {
    this.pagination.currentPage = 1;
    this.searchItem = e.target.value ? e.target.value : '';
    this.role = role;
    this.userService
      .getUsersWithSearch(pagination, this.searchItem, this.role)
      .pipe(debounceTime(1000))
      .subscribe({
        next: (res) => {
          console.log(res);
          this.customerData = res.data.data;
          this.totalPage = res.data.totalPage;
          this.totalRecords = res.data.totalData;
        },
        error: (err) => console.error(err),
        complete: () => console.log('Observable complete'),
      });
  }

  // Method to handle next page
  nextPage() {
    if (this.pagination.currentPage < this.totalPage) {
      this.pagination.currentPage++;
      this.getCustomerCompany(this.pagination);
    }
  }

  onPageChange(page: any) {
    console.log(page);
    this.pagination.currentPage = page;
    this.getCustomerCompany(this.pagination);
  }

  // Method to handle previous page
  previousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.getCustomerCompany(this.pagination);
    }
  }

  onLast() {
    this.pagination.currentPage = this.totalPage;
    this.getCustomerCompany(this.pagination);
  }
  onFirst() {
    this.pagination.currentPage = 1;
    this.getCustomerCompany(this.pagination);
  }
  toggleView(id: any) {
    this.router.navigate(['home/customer/viewcustomerProfile', id]);
    // this.router.navigate(['home/profile/personal-details', id]);
  }
  routeToCustomerDetails(id: any) {
    this.router.navigate(['home/customer/editcustomerProfile', id]);
  }
}
